import { WeakObj } from "@nova/weak-obj"
import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"
import store from "integrations/redux/store"
import { memoize } from "nodash"
import { Selector } from "react-redux"

export const createGenericSidePanelStateSelector = (
    entityCreator: () => {
        id: string
        index: string
        parentId?: string
        archivedTimestamp?: number
    },
    selectSingleEntity: (
        id: string
    ) => Selector<RootState, { id: string; index: string; parentId?: string }>,
    selectAllEntities: Selector<RootState, { id: string; index: string; parentId?: string }[]>
) => {
    const selectSingleIconSidePanelData = memoize((id: string) => {
        const weakObj = new WeakObj(entityCreator(), [
            "id",
            "index",
            "parentId",
            "archivedTimestamp",
        ])
        return createSelector([selectSingleEntity(id)], (entity) =>
            entity
                ? weakObj.refFrom(entity)
                : ({} as {
                      id: string
                      index: string
                      parentId: string
                      archivedTimestamp: number
                  })
        )
    })

    let arr: ReturnType<ReturnType<typeof selectSingleIconSidePanelData>>[] = []
    return createSelector([selectAllEntities], (icons) => {
        const state = store.getState()
        if (
            icons.length === arr.length &&
            icons.every((e, i) => selectSingleIconSidePanelData(e.id)(state) === arr[i])
        ) {
            return arr
        } else {
            arr = icons.map((e) => selectSingleIconSidePanelData(e.id)(state))
            return arr
        }
    })
}
